var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('a',{class:[
			'widget-small success mb-0 coloured-icon btn-widget',
			_vm.type,
			{ 'cursor-pointer': _vm.hasCallback }
		],attrs:{"href":_vm.link,"data-content":_vm.dataContent,"data-toggle":_vm.dataToggle},on:{"click":_vm.callback}},[_c('i',{class:['icon', _vm.icon, 'fa-3x']}),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.value || _vm.value == 0)?_c('b',{staticClass:"counter"},[_vm._v(_vm._s(_vm.value))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }